import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useChannelContext } from '../context/ChannelContext';

const Navbar = ({ isAdmin }) => {
  const { setCurrentFilter } = useChannelContext();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleFilter = (filter) => {
    setCurrentFilter(filter);
    setMobileMenuOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('streambd_admin');
    navigate('/');
    setMobileMenuOpen(false);
  };

  const categories = [
    { key: 'all', label: 'সব চ্যানেল', icon: '📡' },
    { key: 'worldcup', label: 'World Cup', icon: '🏆' },
    { key: 'sports', label: 'Sports', icon: '⚽' },
    { key: 'news', label: 'News', icon: '📺' },
    { key: 'entertainment', label: 'Entertainment', icon: '🎬' },
  ];

  return (
    <>
      <nav style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 12px',
        height: '56px',
        background: 'rgba(10,10,15,0.95)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid var(--border)'
      }}>
        <div style={{
          fontFamily: "'Teko', sans-serif",
          fontSize: '22px',
          fontWeight: 700,
          color: 'var(--accent)',
          letterSpacing: '1px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center'
        }} onClick={() => { setCurrentFilter('all'); navigate('/'); setMobileMenuOpen(false); }}>
          Stream<span style={{ color: 'var(--text)' }}>BD</span>
          <span style={{
            fontSize: '10px',
            color: 'var(--worldcup-glow)',
            marginLeft: '6px',
            background: 'rgba(245,200,66,0.15)',
            padding: '2px 6px',
            borderRadius: '4px',
            fontWeight: 600
          }}>🏆 WC</span>
        </div>

        {/* Desktop Navigation */}
        <div style={{
          display: 'none',
          gap: '4px',
          '@media (min-width: 768px)': { display: 'flex' }
        }} className="desktop-nav">
          {categories.map(cat => (
            <button
              key={cat.key}
              onClick={() => handleFilter(cat.key)}
              style={{
                background: 'none',
                border: 'none',
                color: 'var(--muted)',
                fontSize: '12px',
                fontWeight: 500,
                padding: '6px 12px',
                borderRadius: '6px',
                cursor: 'pointer',
                transition: '0.2s',
                whiteSpace: 'nowrap'
              }}
            >
              {cat.icon} {cat.label}
            </button>
          ))}
        </div>

        {/* Right side - Admin and Mobile Menu */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {isAdmin ? (
            <>
              <button
                onClick={() => navigate('/admin')}
                style={{
                  background: 'var(--accent)',
                  color: '#fff',
                  border: 'none',
                  padding: '5px 12px',
                  borderRadius: '6px',
                  fontSize: '12px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: '0.2s',
                  display: 'none',
                  '@media (min-width: 480px)': { display: 'block' }
                }}
                className="admin-btn-desktop"
              >
                ⚙️ Admin
              </button>
              <button
                onClick={handleLogout}
                style={{
                  background: 'transparent',
                  color: 'var(--muted)',
                  border: '1px solid var(--border)',
                  padding: '5px 12px',
                  borderRadius: '6px',
                  fontSize: '12px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: '0.2s',
                  display: 'none',
                  '@media (min-width: 480px)': { display: 'block' }
                }}
                className="logout-btn-desktop"
              >
                Logout
              </button>
            </>
          ) : (
           <>
            {/* <button
              onClick={() => navigate('/admin/login')}
              style={{
                background: 'var(--accent)',
                color: '#fff',
                border: 'none',
                padding: '5px 12px',
                borderRadius: '6px',
                fontSize: '12px',
                fontWeight: 600,
                cursor: 'pointer',
                transition: '0.2s'
              }}
            >
              ⚙️ Admin
            </button> */}
            </>
          )}

          {/* Mobile Menu Toggle */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--text)',
              fontSize: '24px',
              cursor: 'pointer',
              padding: '4px 8px',
              display: 'block',
              '@media (min-width: 768px)': { display: 'none' }
            }}
            className="mobile-menu-toggle"
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div style={{
        position: 'fixed',
        top: '56px',
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(10,10,15,0.98)',
        zIndex: 998,
        transform: mobileMenuOpen ? 'translateX(0)' : 'translateX(100%)',
        transition: 'transform 0.3s ease',
        padding: '20px',
        overflowY: 'auto',
        display: 'block',
        '@media (min-width: 768px)': { display: 'none' }
      }} className="mobile-menu">
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          {categories.map(cat => (
            <button
              key={cat.key}
              onClick={() => handleFilter(cat.key)}
              style={{
                background: 'var(--card)',
                border: '1px solid var(--border)',
                color: 'var(--text)',
                fontSize: '16px',
                fontWeight: 500,
                padding: '14px 16px',
                borderRadius: '10px',
                cursor: 'pointer',
                transition: '0.2s',
                textAlign: 'left',
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}
            >
              <span style={{ fontSize: '20px' }}>{cat.icon}</span>
              {cat.label}
            </button>
          ))}
          
          {isAdmin && (
            <>
              <button
                onClick={() => { navigate('/admin'); setMobileMenuOpen(false); }}
                style={{
                  background: 'var(--accent)',
                  border: 'none',
                  color: '#fff',
                  fontSize: '16px',
                  fontWeight: 600,
                  padding: '14px 16px',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  transition: '0.2s',
                  textAlign: 'left',
                  marginTop: '8px'
                }}
              >
                ⚙️ Admin Dashboard
              </button>
              <button
                onClick={handleLogout}
                style={{
                  background: 'transparent',
                  border: '1px solid var(--border)',
                  color: 'var(--muted)',
                  fontSize: '16px',
                  fontWeight: 500,
                  padding: '14px 16px',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  transition: '0.2s',
                  textAlign: 'left'
                }}
              >
                🚪 Logout
              </button>
            </>
          )}
        </div>

        <div style={{
          marginTop: '20px',
          paddingTop: '16px',
          borderTop: '1px solid var(--border)',
          color: 'var(--muted)',
          fontSize: '11px',
          textAlign: 'center',
          lineHeight: '1.6'
        }}>
          <div>StreamBD • Live TV & Sports</div>
          <div style={{ fontSize: '10px', opacity: 0.7 }}>
            Developed by ABU SAEEiD × Rifaz
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;